import React from 'react';
import { BookOpen, FlaskConical, Stethoscope, Mail, MessageSquare, Cog, LibraryBig } from 'lucide-react';

const TYPE_ICON = {
  'original-research': FlaskConical,
  review: BookOpen,
  'case-report': Stethoscope,
  letter: Mail,
  commentary: MessageSquare,
  'systematic-review-meta-analysis': LibraryBig,
  edge: FlaskConical,
  others: Cog,
  'methodological-innovation': Cog,
};

const dotPattern = {
  backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.35) 1px, transparent 1px)',
  backgroundSize: '18px 18px',
};

export function ArticleThumbnail({ src, alt = '', type, className = '' }) {
  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className={`h-full w-full object-cover ${className}`}
      />
    );
  }
  const Icon = TYPE_ICON[type] || BookOpen;
  return (
    <div
      className={`relative flex h-full w-full items-center justify-center overflow-hidden bg-gradient-to-br from-navy via-navy-medium to-navy-border ${className}`}
      role="img"
      aria-label={alt || 'Article thumbnail'}
    >
      <div className="absolute inset-0" style={dotPattern} />
      <Icon className="relative h-9 w-9 text-amber" strokeWidth={1.5} />
    </div>
  );
}

export function IssueThumbnail({ src, alt = '', volume, issueNumber, className = '' }) {
  if (src) {
    return (
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className={`h-full w-full object-cover ${className}`}
      />
    );
  }
  return (
    <div
      className={`relative flex h-full w-full flex-col items-center justify-center gap-1 overflow-hidden bg-gradient-to-br from-navy via-navy-medium to-navy-border ${className}`}
      role="img"
      aria-label={alt || 'Issue cover'}
    >
      <div className="absolute inset-0" style={dotPattern} />
      <LibraryBig className="relative h-8 w-8 text-amber" strokeWidth={1.5} />
      {volume && (
        <span className="relative font-display text-sm font-bold text-white">
          Vol. {volume}{issueNumber ? `, No. ${issueNumber}` : ''}
        </span>
      )}
    </div>
  );
}
